<script setup lang="ts">
import { ref, useId, watch } from 'vue'
import { Info } from 'lucide-vue-next'
import type { ExpReadoutPresentation } from '@/ui/exp-readout-presentation'
import type { AppLocale } from '@/i18n/messages'

const props = defineProps<{ model?: ExpReadoutPresentation; locale: AppLocale; context?: string }>()
const dialog = ref<HTMLDialogElement>()
const button = ref<HTMLButtonElement>()
const open = ref(false)
const id = useId()
function show() { dialog.value?.showModal(); open.value = true }
function close() { dialog.value?.close(); open.value = false; button.value?.focus() }
watch(() => props.context, () => { if (open.value) close() })
</script>

<template>
  <div v-show="model?.label || open" class="exp-readout-status" data-exp-readout>
    <button ref="button" type="button" class="exp-readout-button" :class="{ 'is-empty': !model?.label }"
      :disabled="!model?.label" :tabindex="model?.label ? 0 : -1" :aria-hidden="!model?.label || undefined"
      :aria-label="`${model?.label ?? ''} · ${locale === 'en' ? 'EXP reading details' : '经验读数说明'}`"
      :aria-expanded="open" aria-haspopup="dialog" :aria-controls="id" @click="show">
      <span role="status" aria-atomic="true">{{ model?.label || '\u00a0' }}</span><Info aria-hidden="true" />
    </button>
    <dialog :id="id" ref="dialog" class="exp-readout-dialog" :aria-label="locale === 'en' ? 'EXP reading details' : '经验读数说明'"
      @close="open = false" @cancel="open = false">
      <p>{{ model?.description }}</p>
      <button type="button" autofocus @click="close">{{ locale === 'en' ? 'Close' : '关闭' }}</button>
    </dialog>
  </div>
</template>
